package io.horion.auth.api.models.domain

import kotlinx.serialization.Serializable

open class LoginRequest

@Serializable
data class LoginWithEmail(
    val email: String,
    val password: String
): LoginRequest()

@Serializable
data class LoginWithPhone(
    val phone: String,
    val password: String
): LoginRequest()
